module.exports = __webpack_public_path__ + "media/images/application/favicon/logo-184a5c6274f219df9e6e2b637caba59a.png";